import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-dept-document-grid',
  templateUrl: './dept-document-grid.component.html',
  styleUrls: ['./dept-document-grid.component.css']
})
export class DeptDocumentGridComponent implements OnInit {
  title = "Department Documents ";
  itemsPerPage: number=5;
  currentPage: number=1;
  Departmentlist : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

   ngOnInit() {
    this.GetAllDepartmentPagination(this.itemsPerPage,this.currentPage)
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) { 
    if (this.isSearch)
    this.onSearch(this.s, itemsPerPage, pageNo);
    else   
    this.GetAllDepartmentPagination(itemsPerPage, pageNo);
  }

  pageChanged(pageNumber:number){ 
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else 
    this.GetAllDepartmentPagination(this.itemsPerPage, pageNumber);
  }
  // onSearchs(s: Search, itemsPerPage: number, pageNumber: number) {
  //   throw new Error("Method not implemented.");
  // }

  GetAllDepartmentPagination(itemsPerPage: number, pageNo: number){
   
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDepartmentPagination(itemsPerPage,pageNo);
    this.data.subscribe(
         (response: any) => {
          this.Departmentlist= response.DepartmentModel;    
          this.totalItems= response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;           
       
          document.getElementById('loader-spinner').style.display = "none";
         },    
         (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }
      );    
  }

  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.SearchDepartmentsdetails(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.DepartmentModel.length!=0){              
            this.Departmentlist = data.DepartmentModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



  button(){
    alert('Hi');
  }
}




// WEBPACK FOOTER //
// ./src/app/masters/dept-document/dept-document-grid/dept-document-grid.component.ts